import { createCMSArticles } from './CMSArticles';
import { BreadCrumbType } from '../BreadCrumb/breadCrumbSlice';

export default createCMSArticles({
  sectionId: 'BLOG',
  title: 'Blog',
  breadcrumbType: BreadCrumbType.BLOG_ARTICLES,
  crossLink: { name: 'Magazín', pathname: '/magazin' },
});
